import { render, staticRenderFns } from "./NavbarItemLink.vue?vue&type=template&id=4e10a56e"
import script from "./NavbarItemLink.vue?vue&type=script&lang=ts"
export * from "./NavbarItemLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports